module.exports = __webpack_public_path__ + "img/desc6.62397d4e.png";